module.exports = __webpack_public_path__ + "img/floor_f17_01.40fe2200.png";